export const DEVELOPMENT = process.env.NODE_ENV === "development";
export const API_BASE_URL =
  window?._env_?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL;
export const PAYSTACK_KEY = process.env.REACT_APP_PAYSTACK_KEY;
